import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AuthType } from '../../app/config/constants/auth.constants';
import { Auth } from '../models/auth.model';

const initialState: Auth = {
  isAuthenticated: false,
  isFetching: false,
  type: AuthType.LESS,
  accessToken: '',
  refreshToken: '',
  sessionExpired: false,
};

type RefreshLoginDataPayload = Pick<Auth, 'accessToken' | 'refreshToken' | 'isAuthenticated'>;

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    dispatchAuthType: (state, action: PayloadAction<AuthType>) => {
      state.type = action.payload;
      return state;
    },
    refreshAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
      return state;
    },
    refreshLoginData: (state, action: PayloadAction<RefreshLoginDataPayload>) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.isAuthenticated = action.payload.isAuthenticated;
      state.sessionExpired = false;
      return state;
    },
    fetchingRefresh: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
      return state;
    },
    refreshSessionExpired: (state, action: PayloadAction<boolean>) => {
      state.sessionExpired = action.payload;
      return state;
    },
    invalidateSession: () => ({ ...initialState, sessionExpired: true }),
    resetAuhStore: () => initialState,
  },
});

export const AuthSlice = authSlice.actions;
export default authSlice.reducer;
